<template>
  <div class="cpt-credit">
    <div :class="$utils.isMobile() ? 'credit-m' : 'credit'">
      <div class="title-en tit-en" v-if="$i18n.locale == 'zh-CN'">{{ creditData.titleEn }}</div>
      <div class="title tit">{{ creditData.title }}</div>
      <cpt-divider></cpt-divider>
      <div class="content">
        <div class="img-box">
          <img class="img" :src="creditData.imgM" v-if="$utils.isMobile()" alt="">
          <img class="img" :src="creditData.img" v-else alt="">
        </div>
        <div :class="$i18n.locale == 'en-US' ? 'text-en' : 'text'">{{ creditData.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import cptDivider from './cpt-divider.vue';
export default {
  name: 'cpt-credit',
  components: {
    cptDivider
  },
  data() {
    return {
      creditData: this._contentData.creditData
    }
  },

  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-credit{
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 30px 0;
  .credit{
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tit-en{
      color: rgba(51, 51, 51, 0.3);
      text-align: center;
    }
    .tit{
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .content{
      width: 1200px;
      height: 475px;
      position: relative;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .img-box{
        position: absolute;
        top: 0;
        left: 0;
        .img{
          height: 475px;
        }
      }
      .text{
        width: 600px;
        padding: 65px;
        font-size: 22px;
        color: #666;
        // font-family: MiSans-Normal;
        background: #fff;
        box-shadow: 5px 10px 30px rgba(51, 51, 51, 0.1);
        z-index: 9;
      }
      .text-en{
        width: 600px;
        padding: 65px;
        font-size: 20px;
        color: #666;
        // font-family: MiSans-Normal;
        background: #fff;
        box-shadow: 5px 10px 30px rgba(51, 51, 51, 0.1);
        z-index: 9;
        letter-spacing: normal;
      }
    }
  }
  .credit-m{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 15px;
    .tit-en{
      color: rgba(51, 51, 51, 0.3);
      text-align: center;
    }
    .tit{
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .content{
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      .img-box{
        .img{
          width: 100%;
        }
      }
      .text{
        position: absolute;
        bottom: 20px;
        left: 0;
        padding: 15px;
        font-size: 10px;
        color: #fff;
        // font-family: MiSans-Normal;
        background: rgba(64, 126, 160, 0.8);
        z-index: 9;
        margin: 0 15px;
      }
      .text-en{
        position: absolute;
        bottom: 20px;
        left: 0;
        padding: 15px;
        font-size: 10px;
        color: #fff;
        // font-family: MiSans-Normal;
        background: rgba(64, 126, 160, 0.8);
        z-index: 9;
        margin: 0 15px;
        letter-spacing: normal;
      }
    }
  }
}
</style>